import { useState } from 'react';
import { Button, Col, Modal, Row, Spin, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { BtnUploadModal } from '../../style';
import { useDictionaryTranslation } from '../../../../hooks/useDictionaryTranslation';
import { useModalEditImagesList } from '../hooks/useModalEditImagesList';

const fileTypes = ['image/jpeg', 'image/png'];

const ModalEditImagesList = ({ field, value, show, onCloseModal, parents }) => {
  const { translate: t } = useDictionaryTranslation();
  const [isLoading, setIsLoading] = useState(false);

  const { addImageItem, removeImage, imagesList } = useModalEditImagesList({
    field,
    value,
    parents,
  });

  const beforeUpload = async (file) => {
    addImageItem(file);
    return false;
  };

  const onRemoveImg = (img) => {
    removeImage(img.uid);
  };

  const handleAddImages = async () => {
    setIsLoading(true);
    try {
      await onCloseModal({
        imgList:
          imagesList?.map((item) => {
            if (item == null) return null;
            if (typeof item === 'string') return item;
            if (typeof item.img === 'string') return item.img;
            return item;
          }) ?? [],
      });
    } catch (error) {
      console.error('Error saving images:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getDisplayedName = ({ isLoading: isLoadingName, img, file }) => {
    if (isLoadingName) {
      return t('loading');
    }
    if (file) return file.name;
    const nameParts = img.split('/');
    const name = nameParts[nameParts.length - 1];
    return name.length < 33 ? name : `${name.slice(0, 15)}...${name.slice(-15)}`;
  };

  return (
    <>
      <Modal
        visible={show}
        onCancel={onCloseModal}
        title={field.label}
        footer={
          <Button
            onClick={handleAddImages}
            type="primary"
            disabled={isLoading || imagesList.some((item) => item.isLoading)}
          >
            {t('save')}
          </Button>
        }
      >
        <Spin spinning={isLoading}>
          <Col md={24} xs={24}>
            <Row justify="center">
              <Col md={24} xs={24}>
                {' '}
                <Upload
                  accept={fileTypes.join(', ')}
                  listType="picture"
                  beforeUpload={beforeUpload}
                  multiple
                  maxCount={field.limit}
                  onRemove={onRemoveImg}
                  fileList={imagesList.map((item) => {
                    return {
                      uid: item.uid,
                      key: item.uid,
                      name: getDisplayedName(item),
                    };
                  })}
                >
                  <Row justify="center">
                    <Col md={24} xs={24}>
                      <BtnUploadModal disabled={field.limit <= imagesList?.length} icon={<UploadOutlined />}>
                        {t('attachFiles')}
                      </BtnUploadModal>
                    </Col>
                  </Row>
                </Upload>
              </Col>
            </Row>
          </Col>
        </Spin>
      </Modal>
    </>
  );
};

export default ModalEditImagesList;

ModalEditImagesList.propTypes = {
  field: PropTypes.object,
  value: PropTypes.array,
  show: PropTypes.bool,
  onCloseModal: PropTypes.func,
  parents: PropTypes.array,
};
